import React from "react";
import DamagesPane from "../components/DamagesPane";

export default function Daune() {
  return (
    <div data-testid="page-daune">
      <div className="mb-6">
        <h1 className="font-display text-3xl font-extrabold">Registru daune</h1>
        <p className="text-sm text-zinc-500 mt-1">Toate daunele produse pe șantiere — filtrabile pe angajat, șantier și status.</p>
      </div>
      <DamagesPane lockedPersonId={null} showFilters={true} title="Toate daunele" />
    </div>
  );
}
